import actionTypes from './actionTypes'

const dmStorageExperimentActions = {

	initialize() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_INITIALIZE,
		}
	},

	doubleStorage() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_DOUBLE_STORAGE,
		}
	},

	goToMyLibrary() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_GO_TO_MY_LIBRARY,
		}
	},

	referContactSend(values) {
		return {
			...values,
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND,
		}
	},

	referContactSendSuccess() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND_SUCCESS,
		}
	},

	referContactClose() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE,
		}
	},

	referContactCloseSuccess() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE_SUCCESS,
		}
	},

	animationCompleted() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_ANIMATION_COMPLETED,
		}
	},

	referContactMetricsSuccess() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_METRICS_SUCCESS,
		}
	},

	referContactInitialize() {
		return {
			type: actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_INITIALIZE,
		}
	},
}

export default dmStorageExperimentActions
